import builder from '../builder';
import OfficeFileDOC from '../../streamline-icons/bold/office-file-doc-1.svg';

export default builder('OfficeFileDOCBold', OfficeFileDOC);
